export const cards = [
    {
        title:'Varanasi',
        image:process.env.PUBLIC_URL + "/images/blog/varansai.jpg",
        description:'Varanasi, the religious capital of India exists in the Northern part of India for thousands of years. To see its elegance and spectacular views, tourists not only come from India but from overseas. ',
        link:'varanasi'
    },
    {
        title:'Top 6 holiday destinations in India to tour',
        image:process.env.PUBLIC_URL + "/images/blog/top6place.jpg",
        description:'In this world, everything and everyone has marvellous beauty insid them. But, does anyone ever think what can be the beauty of a country? If yes then what it is? Well, it can be so many things lets find out ',
        link:'top6Destination'
    },
    {
        title:'Top 6 sightseeing places in Dehradun',
        image:process.env.PUBLIC_URL + "/images/blog/dehradun.jpg",
        description:" Uttarakhand's capital city, Dehradun is the place which is used to called Dronagiri, the city of Dronacharya at the time of Ramayana and Mahabharata. And both the ancient rivers passes through this city,",
      link:'top6SightseeingDehradun'
    }
]